module.exports = __webpack_public_path__ + "img/hk-back.3c0ba441.png";